<script>
import moment from "moment";
import {mapActions} from "vuex";

export default {
  name: "PortalUpdateRow",
  props: ["portalUpdate"],
  computed: {
    previewText() {
      const maxLength = 10;
      const words = this.portalUpdate.text?.split(/\s+/);

      if(!words || words.length === 0) return "";
      if(words.length < maxLength) return this.portalUpdate.text;

      return words.slice(0, maxLength).join(" ") + " ...";
    },
    date() {
      return moment(new Date(this.portalUpdate.created_at)).format("DD.MM.YYYY");
    }
  },
  methods: {
    ...mapActions("portalUpdates", ["openUpdateDialog"]),
    async onPortalUpdateClick() {
      await this.openUpdateDialog(this.portalUpdate.id);
    }
  }
}
</script>

<template>
  <v-card class="ma-3 pa-2" :elevation="portalUpdate.seen ? 1 : 4" @click="onPortalUpdateClick">
    <v-card-subtitle class="pa-0">
      <span v-if="!portalUpdate.seen" class="badge px-2 mr-1 new-item">NEU</span>
      <span class="thema-badge badge px-2 mr-1">Portal Updates</span>
      <span class="thema-badge badge px-2">{{ date }}</span>
    </v-card-subtitle>
    <v-card-title class="pa-0 primary-text font-weight-bold" style="font-size: 15px; word-break: break-word; line-height: 1.5rem">
      {{ portalUpdate.titel }}
    </v-card-title>
    <v-card-text class="pa-0" v-if="previewText.length > 0">
      {{ previewText }}
    </v-card-text>
  </v-card>
</template>

<style scoped>

</style>
